import { Injectable } from '@angular/core';

@Injectable({
  providedIn: 'root',
})
export class StorageService {
  get(key: string) {
    const _item = localStorage.getItem(key);
    return _item ? JSON.parse(_item) : '';
  }

  set(key: string, data: any) {
    return localStorage.setItem(key, JSON.stringify(data));
  }

  concatSet(key: string, data: any) {
    const a = this.get(key);
    const b = Object.assign(a, data);
    this.set(key, b);
  }

  remove(key: string) {
    return localStorage.removeItem(key);
  }

  clear() {
    return localStorage.clear();
  }

  setSession(key: string, data: any) {
    sessionStorage.setItem(key, JSON.stringify(data));
  }

  concatSetSession(key: string, data: any) {
    const a = this.getSession(key);
    const b = Object.assign(a, data);
    this.setSession(key, b);
  }

  getSession(key: string) {
    const _item = sessionStorage.getItem(key);
    return _item ? JSON.parse(_item) : '';
  }

  removeSession(key: string) {
    return sessionStorage.removeItem(key);
  }

  clearSession() {
    return sessionStorage.clear();
  }

  setCookie(name: string, value: string, days: number) {
    let expires = '';
    if (days) {
      const date = new Date();
      date.setTime(date.getTime() + days * 24 * 60 * 60 * 1000);
      expires = '; expires=' + date.toUTCString();
    }
    document.cookie = name + '=' + (value || '') + expires + '; path=/';
  }

  // getCookie(name: string) {
  //   var nameEQ = name + '=';
  //   var ca = document.cookie.split(';');
  //   for (var i = 0; i < ca.length; i++) {
  //     var c = ca[i];
  //     while (c.charAt(0) == ' ') c = c.substring(1, c.length);
  //     if (c.indexOf(nameEQ) == 0) return c.substring(nameEQ.length, c.length);
  //   }
  // }

  removeCookie(name: string) {
    document.cookie = name + '=; Path=/; Expires=Thu, 01 Jan 1970 00:00:01 GMT;';
  }
}
